import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Modal } from 'react-bootstrap'
import { useParams } from 'react-router-dom';
import UserService from "../../controllers/UserService";
import AuthService from "../../controllers/AuthService";
import rData from "../../files/RiasecData.json";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);


const RiasecFormResult = props => {

  const { roomId, studentId, evaluateT, assessorParam } = useParams();
  let [fullName, setFullName] = useState('');
  let [assessor, setAssessor] = useState('STUDENT');
  let [chartData, setChartData] = useState(null);
  let [top1, setTop1] = useState('');
  let [top2A, setTop2A] = useState('');
  let [top2B, setTop2B] = useState('');
  let [skill, setSkill] = useState(null);
  let [skillList, setSkillList] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  let [homeDNone, setHomeDNone] = useState('');
  let [parentDNone, setParentDNone] = useState('');
  const [showReadMe, setShowReadMe] = useState('');

  const changeAssessor = (role) => {
    if (role) {
      setAssessor(role)
      loadResult(role)
    }
  }

  const loadResult = (role = null) => {
    let assessorTemp = assessor
    if (!AuthService.getCurrentUserId() || assessorParam) {
      assessorTemp = 'PARENT'
      setAssessor('PARENT')
      setHomeDNone('d-none')
    } else {
      setParentDNone('d-none')
    }
    if (role) {
      assessorTemp = role
    }
    UserService.getRiasecResult(roomId, studentId, assessorTemp)
      .then((response) => {
        setChartData(null)
        setTop1('')
        setTop2A('')
        setTop2B('')
        setSkill(null)

        // TOP Data
        let res = null
        if (response.data && response.data.data && response.data.data[0]) {
          res = response.data.data[0]
          const top = res.top
          if (top.top1.length > 0) {
            if (top.top1.length === 1) {
              setTop1(top.top1[0])
              if (top.top2.length > 0) {
                if (top.top2.length === 1) {
                  setTop2A(top.top2[0])
                } else if (top.top2.length === 2) {
                  setTop2A(top.top2[0])
                  setTop2B(top.top2[1])
                }
              }
            } else if (top.top1.length === 2) {
              setTop1(top.top1[0])
              setTop2A(top.top1[1])
            }
          }

          // Chart Js Data
          const percent = res.percent
          const total = res.total
          const keyProp = {
            r: `Realistic`,
            i: `Investigation`,
            a: `Artistic`,
            s: `Social`,
            e: `Enterprising`,
            c: `Convention`
          }
          let riasecList = []
          const sortable = Object.fromEntries(
            Object.entries(total).sort(([, a], [, b]) => a - b)
          );
          for (var val in sortable) {
            riasecList.push([
              val,
              keyProp[val],
              percent[val],
              total[val]
            ])
          }
          setSkillList(riasecList)
          const chartValue = [
            percent.r,
            percent.i,
            percent.a,
            percent.s,
            percent.e,
            percent.c,
          ]
          setChartData({
            labels: [`Realistic`, `Investigation`, `Artistic`, `Social`, `Enterprising`, `Convention`],
            datasets: [
              {
                label: 'ค่าคะแนน',
                data: chartValue,
                backgroundColor: 'rgba(98, 222, 170, 0.6)',
                borderColor: 'rgba(98, 222, 170, 1)',
                borderWidth: 2
              }
            ],

          })

          // Set Personality and Occupation Data
          let s = []
          if (top && top.top1Select && top.top1Select !== null) {
            if (top.top1Select.length >= 3) {
              top.top1Select = top.top1Select.substring(0,2);
            } 
            const t1S = rData.findIndex(x => x.riasec === top.top1Select);            
            if (t1S) {
              s.push(rData[t1S])
            }
          } else {
            if (top.top121Abb) {
              const t1 = rData.findIndex(x => x.riasec === top.top121Abb);
              if (t1) {
                s.push(rData[t1])
              }
            }
            if (top.top122Abb) {
              const t2 = rData.findIndex(x => x.riasec === top.top122Abb);
              if (t2) {
                s.push(rData[t2])
              }
            }
          }
          setSkill(s)

          // Set show readme
          console.log('readme ', top)
          let SReadme = 'hide'
          if (top && top.top1Select && top.top1Select !== null) {
            SReadme = 'show'
          }
          setShowReadMe(SReadme)
        }
      })
  }

  useEffect(() => {
    try {
      UserService.getUserById(studentId)
        .then((response) => {
          if (response.data.data && response.data.data.fullName) {
            setFullName(response.data.data.fullName)
          }
        }).then((evaluate) => {
          console.log();
          if (evaluateT === 'evaluate' && AuthService.getUserRole() === 'teacher') {
            setAssessor('TEACHER')
            loadResult('TEACHER')
          } else {
            loadResult()
          }

        })
    } catch (error) {

    }

  }, []);

  return (
    <div className='riasec-result-page main-detail'>
      {
        (AuthService.getUserRole() === 'teacher' || AuthService.getUserRole() === 'headmaster') ? (
          <Row className={`border-bottom-blue ${evaluateT == 'evaluate' ? 'd-none' : ''}`}>
            <div className="pt-3 pb-0 btn-main-group text-center w-100">
              <Button variant="m-2 py-md-1 font-sarabun-bold"
                className={`assessor ${assessor === 'STUDENT' ? 'active' : 'inactive'}`}
                onClick={() => changeAssessor('STUDENT')}
              >นักเรียน</Button>
              <Button variant="m-2 py-md-1 font-sarabun"
                className={`assessor ${assessor === 'TEACHER' ? 'active' : 'inactive'}`}
                onClick={() => changeAssessor('TEACHER')}
              >คุณครู</Button>
              <Button variant="m-2 py-md-1 font-sarabun"
                className={`assessor ${assessor === 'PARENT' ? 'active' : 'inactive'}`}
                onClick={() => changeAssessor('PARENT')}
              >ผู้ปกครอง</Button>
            </div>
          </Row>
        ) : (
          <span />
        )
      }

      <Row>
        <Col xs={12} className='main-detail riasec-header text-center'>
          <h1 className='headline1 primary-text mt-3'>RIASEC Individual Report</h1>
          <h2 className='headline2'>RIASEC Statistics (Score)</h2>
          <h3 className='fullname primary-text font-sarabun-bold' data-testid='student-name'>{fullName}</h3>
        </Col>
      </Row>

      {
        (chartData && skill) ? (
          <Row>
            <Col xs={12} className='main-detail riasec-canvas2'>
              <Row>
                <Col xs={7} className='d-none d-lg-inline-flex' data-testid='riasec-score-chart'>
                  <Radar data={chartData}
                    options={{
                      plugins: {
                        legend: {
                          display: false
                        }
                      }, scales: {
                        r: {
                          pointLabels: {
                            font: {
                              size: 20
                            }
                          },
                          max: 25,
                          min: 0,
                          ticks: {
                            stepSize: 5
                          }
                        }
                      }
                    }}
                    className='m-auto' />
                </Col>

                <Col xs={5} className='d-none d-lg-flex' data-testid='riasec-score-list'>
                  <div className='mt-auto mb-auto'>
                    {
                      (skillList && skillList.length > 0) ? (
                        skillList.map((item, index) => (
                          <p key={index} className='skill-list font-sarabun' data-testid={`riasec-result-${item[1]}`}>
                            {
                              (index > 0) ? (
                                <br />
                              ) : (
                                <span />
                              )
                            }
                            {item[1]} : <span className='score font-sarabun-bold'>{item[2]}%</span>
                          </p>
                        ))
                      ) : (
                        <span />
                      )
                    }
                  </div>
                </Col>
              </Row>

            </Col>
            <Col xs={12} className='main-detail riasec-canvas2'>
              <Row>
                <Col xs={12} className='d-inline d-lg-none'>
                  <Radar data={chartData}
                    options={{
                      plugins: {
                        legend: {
                          display: false
                        }
                      }, scales: {
                        r: {
                          pointLabels: {
                            font: {
                              size: 12
                            }
                          }
                        }
                      }
                    }}
                    className='m-auto' />
                </Col>

                <Col xs={12} className='d-inline d-lg-none mb-3' data-testid='riasec-score-list'>
                  {
                    (skillList && skillList.length > 0) ? (
                      skillList.map((item, index) => (
                        <p key={index} className='skill-list font-sarabun pl-5'>

                          {item[1]} : <span className='score font-sarabun-bold'>{item[2]}%</span>
                        </p>
                      ))
                    ) : (
                      <span />
                    )
                  }
                </Col>
                <Col xs={12} className="text-center mb-2 d-none d-lg-inline">
                  <u className='text-green-evaluate click-pointer what-is-raisec' onClick={() => { setModalShow(true); }}>RIASEC คืออะไร?&gt;</u>
                </Col>
                {
                  (showReadMe && showReadMe === 'show') ? (
                    <Col xs={12} className='mb-lg-5'>
                      <h2 className='font-sarabun-bold primary-text text-center mb-2 readme-bf mb-lg-4'>เราอยากให้อ่านก่อนที่จะดูผลลัพธ์ด้านล่าง</h2>
                      <span className='font-sarabun mb-3 t-18'>
                        ลองดูจากกราฟสิ จะเห็นว่าเราในตัวเธอมีความหลากหลายทั้งในบุคลิกภาพ ความชอบและความสนใจ แต่... ไม่ใช่เรื่องที่ผิดอะไรเลยนะ แถมเป็นเรื่องที่ดีด้วยซ้ำ
                        เพราะมันอาจจะเหมาะกับหลากหลายอาชีพที่น่าสนใจ เอาเป็นว่าสุดท้ายผลลัพธ์ของอาชีพที่เราเลือกมาจะไม่ได้เป็นตัวกำหนด แต่เราคิดว่ามันเหมาะกับเธอที่สุดในช่วงเวลานี้นะ เราไปดูผลลัพธ์ด้านล่างกันเลย!!
                      </span>
                    </Col>
                  ) : (
                    <span />
                  )}
                <Col xs={12} className="text-center mb-2 mt-3 d-inline d-lg-none">
                  <u className='text-green-evaluate click-pointer what-is-raisec' onClick={() => { setModalShow(true); }}>RIASEC คืออะไร?&gt;</u>
                </Col>
              </Row>
            </Col>
            <Col xs={12} className='main-detail most-skill py-3'>
              <Row className=''>
                <Col xs={12} lg={4} className='text-center d-flex'>
                  <Row className='m-auto'>
                    <Col xs={12} className='position-relative'>
                      <img src='/images/riasec/result-circle.png' className='riasec-circle' width={'100%'} alt='circle' />
                      <div className={`r-${skill.length} result-circle-frame position-absolute d-flex`}>
                        <div className='m-auto result-circle-text'>
                          {
                            (skill && skill.length > 0) ? (
                              skill.map((item, index) => (
                                <span key={index}>
                                  {
                                    (index > 0) ? (
                                      <br />
                                    ) : (
                                      <span />
                                    )
                                  }
                                  {item.riasec}
                                </span>
                              ))
                            ) : (
                              <span></span>
                            )
                          }
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="d-block d-md-none"> <h1 className='headline font-sarabun-bold text-center'>Most Remarkable RIASEC Skills</h1></Col>
                    <Col xs={6} className='riasec-top'>
                      <div>
                        <img src='/images/riasec/top1.png' className='r-icon' alt='top1' />
                      </div>
                      <div className='top1 ml-4' data-testid='riasec-top1'>{top1}</div>
                    </Col>
                    <Col xs={6} className='riasec-top'>
                      <div>
                        <img src='/images/riasec/top2.png' className='r-icon' alt='top2' />
                      </div>
                      <div className='top2 ml-4' data-testid='riasec-top21'>{top2A}</div>
                      <div className='top2 ml-4' data-testid='riasec-top22'>{top2B}</div>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} lg={8}>
                  <h1 className='headline font-sarabun-bold text-center d-none d-md-block'>Most Remarkable RIASEC Skills</h1>
                  <Row>
                    <Col xs={12} className='riasec-detail py-3'>
                      {
                        (skill && skill.length > 0) ? (
                          skill.map((item, index) => (
                            <div key={index}>
                              {
                                (skill && skill.length > 1) ? (
                                  <h3>{item.riasec}</h3>
                                ) : (
                                  <span></span>
                                )
                              }
                              <span className="font-sarabun-bold t-20">
                                {item.personality}
                              </span>
                            </div>
                          ))
                        ) : (
                          <div></div>
                        )
                      }
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col xs={12} className='main-detail recommend-career'>
              <div className='frame mt-5'>
                <div className='detail pb-5'>
                  {
                    (skill && skill.length > 0) ? (
                      skill.map((item, index) => (
                        <div key={index}>
                          <h2 className='font-sarabun-bold primary-text text-center'>{item.riasec} - อาชีพที่อาจจะเป็นไปได้สำหรับบุคลิกภาพนี้</h2>
                          <span className='font-sarabun mb-3 t-20'>
                            {item.occupation}
                          </span>
                        </div>
                      ))
                    ) : (
                      <div></div>
                    )
                  }
                </div>
              </div>

              <div className='button-press text-center'>
                <a href={`/report/riasec/export/${assessor.toLowerCase()}/${roomId}/${studentId}`} className="font-sarabun-bold btn x-3 t-18" rel="noreferrer" target='_blank' style={{ "minWidth": "116px" }}>EXPORT</a>
                <a href="/" className={`${homeDNone} ml-3 font-sarabun-bold btn x-3 t-18`} style={{ "minWidth": "116px" }}>กลับหน้าหลัก</a>
                <p className={`${parentDNone} mt-2 font-sarabun`}>*ผู้ปกครองสามารถดูรายงานได้จากคุณครู หรือแสกน QR CODE เดิมอีกครั้ง</p>
              </div>
            </Col>
          </Row>
        ) : (
          <div className='no-result text-center font-sarabun-bold mt-4'>ยังไม่มีการประเมิน</div>
        )
      }
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => { setModalShow(false); }}
      />
    </div>
  )


  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        className="strength-modal"
        centered
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <Row className="pt-0 pb-4 person-choose-strength px-md-4">
            <Col>
              {/* ---------------------------------------------------- */}
              <div className="px-2 px-md-4 w-100">

                <Row className="px-0" >
                  <Col xs={12}>
                    <h2 class="text-green pb-3 py-md-3 text-center">RIASEC คืออะไร?</h2>
                    <p className='font-sarabun-bold'>ค้นหาตัวตนผ่านมิติอาชีพอย่างครบถ้วนตามทฤษฎีของ Prof. John Holland (RIASEC) ด้วย Task-based Activitie</p>
                  </Col>
                  <Col xs={12}>
                    <h2 class="text-green pb-3 py-md-3 text-center">ทฤษฎีของ Holland</h2>
                    <p className='font-sarabun-bold'>
                      <ul>
                        <li>ได้รับการยอมรับและถูกนำไปใช้ในการให้คำปรึกษาด้านอาชีพอย่างกว้างขวาง</li>
                        <li>รับรองโดยงานวิจัยที่ต่อเนื่องกว่า 60 ปี</li>
                        <li>ถูกนำไปใช้ในโรงเรียน มหาวิทยาลัยและองค์กรทั่วโลก</li>
                        <li>ใช้โดยกระทรวงแรงงานของสหรัฐอเมริกา</li>
                        <li>ใช้โดยหน่วยงานรัฐบาลทั่วโลก เช่น ออสเตรเลีย แคนาดา สวิตเซอร์แลนด์ ฯลฯ</li>
                      </ul>
                    </p>
                  </Col>

                </Row>
                <Row className="py-2 mt-3">
                  <Col xs={12} md={5} className="">
                    <img src='/images/riasec/riasec_meaning.png' width={'100%'} alt='Riasec Meaning' />
                  </Col>
                  <Col xs={12} md={7} className="d-flex">
                    <div className='blue-bg p-3 p-md-5 t-1 m-auto font-sarabun-bold border-radius-125'>
                      <p className='text-indent-18'><span className='text-green'>R:</span> ชอบการลงมือทำจริงชอบกีฬาและกิจกรรมกลางแจ้ง</p>
                      <p className='text-indent-18'><span className='text-green'>I:</span> สนใจในวิทยาศาสตร์และการแสวงหาความรู้แขนงต่างๆ</p>
                      <p className='text-indent-18'><span className='text-green'>A:</span> ชอบช่วยเหลือผู้อื่น อยากเห็นผู้อื่นพัฒนาชอบสร้างความสัมพันธ์ที่ดีกับคนรอบข้าง</p>
                      <p className='text-indent-18'><span className='text-green'>S:</span> มีความคิดสร้างสรรค์มีจินตนาการ เชื่อในสัญชาตญาณของตัวเอง</p>
                      <p className='text-indent-18'><span className='text-green'>E:</span> มีความเป็นผู้นำสามารถโน้มน้าวใจ และมีอิทธิพลต่อการตัดสินใจของผู้อื่น</p>
                      <p className='text-indent-18'><span className='text-green'>C:</span> ชอบจัดระบบข้อมูลตัวเลข มีความเป็นระเบียบสูง</p>
                    </div>
                  </Col>
                </Row>
              </div>

              {/* ---------------------------------------------------- */}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }
}


export default RiasecFormResult